import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import {
  Directive,
  ElementRef,
  HostListener,
  Injector,
  Input,
  Type,
} from '@angular/core';
import { DIALOG_DATA, isLargeScreen } from '../../../global.variable';
import { DataCheckService } from '../services/data-check.service';

@Directive({
  selector: '[gtappPopover]',
  standalone: false,
})
export class PopoverDirective {
  @Input('gtappPopover') popoverComponent!: Type<any>;
  @Input() popoverData: any;

  overlayRef?: OverlayRef;

  closeTimeout?: any;
  triggerHover = false;
  popoverHover = false;
  largeView: Boolean = isLargeScreen;

  isAdmin = this.dataCheckService?.isUserAdmin();
  isDispatchUser = this.dataCheckService?.isDispatchUser();

  constructor(
    private el: ElementRef<HTMLElement>,
    private overlay: Overlay,
    private injector: Injector,
    private dataCheckService: DataCheckService,
  ) {}

  @HostListener('mouseenter')
  onTriggerEnter() {
    this.triggerHover = true;
    clearTimeout(this.closeTimeout);
    if (
      !this.overlayRef &&
      this.largeView &&
      (this.isAdmin || this.isDispatchUser)
    ) {
      this.openPopover();
    }
  }

  @HostListener('mouseleave')
  onTriggerLeave() {
    this.triggerHover = false;
    this.scheduleClose();
  }

  private openPopover() {
    const positionStrategy = this.overlay
      .position()
      .flexibleConnectedTo(this.el.nativeElement)
      .withPush(true)
      .withViewportMargin(16)
      // .withFlexibleDimensions(false)
      .withPositions([
        {
          originX: 'center',
          originY: 'bottom',
          overlayX: 'start',
          overlayY: 'top',
        },
        {
          originX: 'center',
          originY: 'top',
          overlayX: 'start',
          overlayY: 'bottom',
        },

        {
          originX: 'end',
          originY: 'bottom',
          overlayX: 'start',
          overlayY: 'top',
        },
        {
          originX: 'start',
          originY: 'bottom',
          overlayX: 'end',
          overlayY: 'top',
        },
      ]);

    this.overlayRef = this.overlay.create({
      positionStrategy,
      hasBackdrop: false,
      scrollStrategy: this.overlay.scrollStrategies.reposition(),
      panelClass: 'gt-popover-panel',
    });

    const injector = Injector.create({
      providers: [{ provide: DIALOG_DATA, useValue: this.popoverData }],
      parent: this.injector,
    });

    const portal = new ComponentPortal(this.popoverComponent, null, injector);
    this.overlayRef.attach(portal);

    let overlayContainer: any = document.querySelector(
      '.cdk-overlay-container',
    );
    if (overlayContainer) {
      overlayContainer.style['z-index'] = '1004';
    }

    const popoverEl = this.overlayRef.overlayElement;

    popoverEl.addEventListener('click', () => {
      // prevent closing of popver when a click inside the popover
      this.popoverHover = true;
      clearTimeout(this.closeTimeout);
    });
    // Listen for mouse enter/leave on the popover itself
    popoverEl.addEventListener('mouseenter', () => {
      this.popoverHover = true;
      clearTimeout(this.closeTimeout);
    });

    popoverEl.addEventListener('mouseleave', () => {
      this.popoverHover = false;
      this.scheduleClose();
    });
  }

  private scheduleClose() {
    clearTimeout(this.closeTimeout);

    this.closeTimeout = setTimeout(() => {
      if (!this.triggerHover && !this.popoverHover) {
        this.closePopover();
      }
    }, 150);
  }

  private closePopover() {
    this.overlayRef?.dispose();
    this.overlayRef = undefined;
  }
}
